<template>
  <div class="myaccount">
      <h2>
          {{isReal?$t('real_account'):$t('demo_account')}}
      </h2>
      <div class="account-btns">
          <Button type="primary" @click="getAccounts()">{{$t('real_account')}}</Button>
          <Button type="primary" @click="getAccounts(0)">{{$t('demo_account')}}</Button>
          <Button type="primary" @click="openDialog('real')" v-show="isReal">{{$t('rg_createreal')}}</Button>
          <Button type="primary" to="/registerDemo" class="register-demo" v-show="!isReal">{{$t('rg_registdemo')}}</Button>
      </div>
      <Table :columns="columns" :data="accounts" :loading="loading">
		  <template slot-scope="{ row }" slot="leverage">
			  <span>1:{{ row.leverage }}</span>
		  </template>
		  <template slot-scope="{ row }" slot="action">
				<div>
					<img src="../../assets/image/tablesetting.png" alt="">
					<ul class="tableSetting">
						<!-- <li>{{$t('agent_setdefault')}}</li>
						<li>{{$t('agent_tothisacc')}}</li>
						<li>{{$t('agent_currpositon')}}</li>
						<li @click="dialogLeverage(true,row)">{{$t('modify')}}</li> -->
						<li @click="dialogReset(true,row)">{{$t('reset')}}</li>
					</ul>
				</div>
		  </template>
	  </Table>
      <open-real :length="accounts.length" :open-dialog="isOpenReal"  @closeDialogReal="dialogReal"></open-real>
      <modify-leverage :open-dialog="isOpenLeverage" :crtAccount="crtAccount"  @closeDialogLeverage="dialogLeverage"></modify-leverage>
      <reset-password :open-dialog="isOpenReset" :crtAccount="crtAccount"  @closeDialogReset="dialogReset"></reset-password>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import OpenReal from '@/views/account/OpenReal.vue'
import ModifyLeverage from '@/views/account/ModifyLeverage.vue'
import ResetPassword from '@/views/account/ResetPassword.vue'



export default {
  name: 'Home',
  components: {
    OpenReal, 
    ModifyLeverage,
    ResetPassword
  },
  data(){
    return{
        loading:false,
		isReal: 1,
        columns: [],
		columnsShow: [],
        accounts: [],
        isOpenReal:false,
        isOpenLeverage:false,
        isOpenReset:false,
		crtAccount:{}
    }
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        this.getAccounts()
    },
    methods:{
        getAccounts(type){
			this.isReal = type == 0 ? type : 1
			if(this.isReal == 1){
				this.columnsShow = ['account','typeName','leverage','currency','balance','equity','action']
			}else {
				this.columnsShow = ['account','typeName','leverage','currency','balance','equity']
			}
			this.initColumns()
			this.loading = true
            this.$axios.get('/api/MyAccount/Index',{
				params:{
					isReal:this.isReal
				}
			})
            .then(async (res) => {
				let dt = res.data
                
				this.loading = false
                if(dt.status == 1){
					this.accounts = dt.obj
                }else{
                    this.$Message.error(dt.msg)
                }
            })
            .catch((err) => {
				this.loading = false
			})
        },
		initColumns() {
			let originColumns = {
				account: {
					title: this.$t('MT4account'),
					key: 'account'
				},
				typeName: {
					title: this.$t('accountType'),
					key: 'typeName'
				},
				leverage: {
					title: this.$t('leverage'),
					slot: 'leverage'
				},
				currency: {
					title: this.$t('currency'),
					key: 'currency'
                },
                balance: {
					title: this.$t('balance'),
					key: 'balance'
				},
				equity: {
					title: this.$t('networth'),
					key: 'equity'
				},
				action: {
					title: this.$t('manage'),
					slot: 'action'
				}
			}
			let columns = []
			
			this.columnsShow.forEach((k) => {
				columns.push(originColumns[k])
			})
			
			this.columns = columns
		},
        openDialog(value){
            if(value == 'real'){
				this.dialogReal(true)
            }
        },
        dialogReal(val){
            this.isOpenReal = val
        },
        dialogLeverage(val,act){
            this.isOpenLeverage = val
			this.crtAccount = act
        },
        dialogReset(val,act){
            this.isOpenReset = val
            this.crtAccount = act
            // console.log(this.crtAccount)
        }
    }
}
</script>
<style lang="less">
.myaccount{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .account-btns{
        position: absolute;
        right: 0;
        top: 0;
    }
	.register-demo{
		display: inline-flex;
		align-items: center;
	}
    .ivu-table-tbody tr td:last-child .ivu-table-cell div{
        width: 50px;
        margin: 0 auto;
        position: relative;
        cursor: pointer;
        line-height: 60px;
    }
    .ivu-table-tbody tr td:last-child .ivu-table-cell div::after{
            content: "";
            position: absolute;
            right: -2px;
            top: 24px;
            border-top: 5px solid #8b8b8c;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
    }
    .tableSetting{
        display: none;
        position: absolute;
        top: 45px;
        right: -38px;
        z-index: 9999;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,.2);
        background: #ffffff;
        li{
            line-height: 60px;
            min-width: 120px;
        }
    }
    .ivu-table-tbody tr td:last-child .ivu-table-cell div:hover .tableSetting{
        display: block;
        // background: chartreuse;
    }
	.ivu-table-tip td{
		width: auto!important;
	}
}
</style>
